Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-cart-navigation');
    var model = null;
    var firstRun = true;

    if ($wrapper.length < 1)
        return;

    $.each($wrapper, function (i, wrapper) {

        wrapper.update = function() {
            var html = Vendd.Handlebars.parse("cartNavigation", model);
            wrapper.bind(html);
        };

        wrapper.bind = function bind(html) {
            $wrapper.html(html);
            if (firstRun) {
                $wrapper.removeClass('x-initializing');
                firstRun = false;
            }
        };

        Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, wrapper, function (envelope) {
            model = envelope.message.data.Cart;
            wrapper.update();
        });
    });
});